export default [
  {
    // 1. DEM处理
    name: 'process',
    base: {
      url: '/Dem/process',
      method: 'post',
      headers: {},
      data: {}
    },
    // DEM 计算可能由后端心跳维持较长时间，前端不设置固定超时。
    config: {
      timeout: 0
    }
  },
  {
    // 2. 查询任务状态
    name: 'getTaskState',
    base: {
      url: '/Dem/task/',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {}
  },
  {
    // 3. 下载文件 /task/{taskId}/download/{fileName}
    name: 'download',
    base: {
      url: '/Dem/task/',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {}
  },
  {
    // 4. 获取文件库信息
    name: 'getLibraryInfo',
    base: {
      url: '/Dem/library/info',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {}
  }
]
